function setRefAddressList (selectedSystemConfig) {
  const refAddressList = selectedSystemConfig['refregerant'].map(elm => elm.Address)
  const tempRefList = []
  for (let i = 0; i < 16; i++) {
    if (refAddressList.includes(i)) {
      tempRefList.push({
        text: i, value: i, disabled: false
      })
    } else {
      tempRefList.push({
        text: i, value: i, disabled: true
      })
    }
  }
  return tempRefList
}

function setRcAddressList (selectedSystemConfig) {
  const rcAddressList = selectedSystemConfig['controller'].map(elm => elm.Address)
  const tempRcList = []
  for (let i = 0; i < 16; i++) {
    if (rcAddressList.includes(i)) {
      tempRcList.push({
        text: i, value: i, disabled: false
      })
    } else {
      tempRcList.push({
        text: i, value: i, disabled: true
      })
    }
  }
  return tempRcList
}

module.exports = {
  setRefAddressList,
  setRcAddressList
}
